import { createStore, applyMiddleware, compose } from "redux";
import { browserHistory } from "react-router";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import reducers from "./reducers";
import tracker from "./middleware/tracker";
import logger from "./middleware/logger";

function configureStore(initialState) {
  const composeEnhancers = typeof window === "object" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(
      {
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      }
      )
    : compose;

  const enhancer = composeEnhancers(
    applyMiddleware(logger, thunk, tracker, routerMiddleware(browserHistory))
  );

  const store = createStore(reducers, initialState, enhancer);

  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./reducers", () => {
      /* eslint-disable */
      store.replaceReducer(require("./reducers").default);
      /* eslint-enable */
    });
  }

  if (typeof window !== "undefined") {
    window.$$store = store;
  }
  return store;
}

export default configureStore;



// WEBPACK FOOTER //
// ./assets/shared/store.js